import { createRequest, getError } from "Utils/requestUtils";
import { call, put, takeLatest } from "redux-saga/effects";
import { AkaHealthConfig, OperationType } from "./akaHealthConfigInterfaces";
import {
  akaHealthConfigStart,
  akaHealthConfigSucceeded,
  operationFailed,
} from "./akaHealthConfigSlice";

export function* akaHealthConfig({
  payload,
}: ReturnType<typeof akaHealthConfigStart>): any {
  try {
    const finalEndpointUrl = `/open/insurance/life/price/akahealth/configurations/${payload.customerId}`;

    const { data } = yield call(createRequest, {
      method: "get",
      url: finalEndpointUrl,
    });

    yield put(akaHealthConfigSucceeded(data as AkaHealthConfig));
  } catch (error) {
    yield put(
      operationFailed({
        operationType: OperationType.AKA_HEALTH_CONFIG,
        response: getError(error),
      }),
    );
  }
}

export function* akaHealthConfigSaga(): Generator {
  yield takeLatest(akaHealthConfigStart, akaHealthConfig);
}
